module.exports = __webpack_public_path__ + "static/media/group-3.d0169ee1.png";